import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyPacientes } from '../../components/Pacientes/ContentBodyPacientes'
import './Pacientes.css'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const Pacientes = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();

    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='Usuarios'  >
                <div className='headerUsuarios'>
                    <HeaderHome
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className="bodyUsuarios">
                    <ContentBodyPacientes 
                        MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux}
                    />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
